/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_3_AInputs */

const en_vc_onl_faq_3_a = /** @type {(inputs: Vc_Onl_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some graphics drivers have trouble with WebGPU. Use the compatibility mode link under the app, which forces WebGL2. Make sure your browser is up to date, and try Chrome or Edge if the problem continues.`)
};

const zh_vc_onl_faq_3_a = /** @type {(inputs: Vc_Onl_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分显卡驱动对 WebGPU 支持不好。点击应用下方的「兼容模式」链接，强制使用 WebGL2。同时确保浏览器是最新版；如果仍有问题，换 Chrome 或 Edge 试试。`)
};

/**
* | output |
* | --- |
* | "Some graphics drivers have trouble with WebGPU. Use the compatibility mode link under the app, which forces WebGL2. Make sure your browser is up to date, and..." |
*
* @param {Vc_Onl_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_3_a = /** @type {((inputs?: Vc_Onl_Faq_3_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_3_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_3_a(inputs)
	return zh_vc_onl_faq_3_a(inputs)
});
export { vc_onl_faq_3_a as "vc.onl.faq.3.a" }